// Aviso de versión nueva: el navegador (o la app instalada) puede seguir con una copia vieja de la página aunque ya haya una versión nueva publicada.
// Cada versión publicada trae archivos con otro nombre (assets/index-XXXX.js); si el de index.html ya no es el que está corriendo, hay una versión nueva.

export const runningBundle = (doc = document) => {
  const el = doc.querySelector('script[type="module"][src*="/assets/index-"]');
  if (!el) return null;
  try { return new URL(el.getAttribute('src'), doc.baseURI || 'http://localhost/').pathname; } catch { return null; }
};

export const publishedBundle = (html) => String(html || '').match(/\/assets\/index-[\w-]+\.js/)?.[0] || null;

// true si hay una versión más nueva que la que corre; false si es la misma o no se puede saber (sin red, desarrollo, respuesta rara).
export const isOutdated = async (doc = document, fetchFn = fetch) => {
  const running = runningBundle(doc);
  if (!running) return false;
  try {
    const res = await fetchFn('/index.html', { cache: 'no-store' });
    if (!res.ok) return false;
    const latest = publishedBundle(await res.text());
    return Boolean(latest) && latest !== running;
  } catch {
    return false;
  }
};

// Borra la copia guardada de la app (service workers y cachés) y recarga: la misma acción de «Resetear Caché».
export const refreshApp = async () => {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if ('caches' in window) {
      const names = await caches.keys();
      await Promise.all(names.map((n) => caches.delete(n)));
    }
  } finally {
    window.location.reload();
  }
};
